import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Dots');

class Dots extends PureComponent {

    render() {
        const { children, className, type } = this.props;
        return (
            <div className={bem('dots', type, className)}>
                <span className={bem('dot')} />
                <span className={bem('dot')} />
                <span className={bem('dot')} />
                {children}
            </div>
        );
    }
}

Dots.propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(['primary', 'secondary']),
    children: PropTypes.node,
};

Dots.defaultProps = {
    type: 'primary',
};

export default Dots;
